// ISO 13616: country length table plus the mod-97 checksum. Mirrors Domain/Shopping/Models/Customers/IbanValidator.cs.
const COUNTRY_LENGTHS = new Map<string, number>(
  ('AT20 BE16 BG22 CH21 CY28 CZ24 DE22 DK18 EE20 ES24 FI18 FR27 GB22 GR27 HR21 HU28 IE22 IT27 LT20 ' +
    'LU20 LV21 MK19 MT31 NL18 NO15 PL28 PT25 RO24 RS22 SE24 SI19 SK24 TR26')
    .split(' ')
    .map((entry): [string, number] => [entry.slice(0, 2), Number(entry.slice(2))])
);

const MAX_IBAN_LENGTH = 34;
const MOD = 97;
const BASIC_FORMAT = /^[A-Z]{2}\d{2}[A-Z0-9]+$/;

const normalizeIban = (value: string | undefined | null): string =>
  (value ?? '').replace(/\s+/g, '').toUpperCase();

const isValidIban = (value: string | undefined | null): boolean => {
  const iban = normalizeIban(value);

  if (!BASIC_FORMAT.test(iban) || iban.length > MAX_IBAN_LENGTH) return false;
  if (COUNTRY_LENGTHS.get(iban.slice(0, 2)) !== iban.length) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let remainder = 0;
  for (const char of rearranged) {
    const digits = /\d/.test(char) ? char : String(char.charCodeAt(0) - 55);
    for (const digit of digits) {
      remainder = (remainder * 10 + Number(digit)) % MOD;
    }
  }

  return remainder === 1;
};

export { isValidIban, normalizeIban };
